/**
 * The job screen's words for its Visits band — `docs/visit-page.md` §26.5,
 * Board 17 C and E (and §27.7's two authorised additions: *<n> are missing*,
 * and one band line per approved quote).
 *
 * Every string here is the board's, so the strings checker finds each of them
 * in this file and nowhere else. The values (Q-2051, 1 day, $1,140.00, the
 * dates) come from `GET /api/v1/jobs/:id/visit-check`; this file only says
 * them.
 */
import { formatHours, formatMoneyText } from '../lib/format.js'

const days = (n: number) => `${n} ${n === 1 ? 'day' : 'days'}`

/** *Thu Oct 22, 2:00 AM* — when the daily check found it. */
const found = (iso: string) => {
  const at = new Date(iso)
  const day = at.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })
  const time = at.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
  return `${day.replace(',', '')}, ${time}`
}

/** *Apr 2* — the day an old quote was approved. */
const approvedOn = (iso: string) =>
  new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })

export const JOB_VISITS_BAND = {
  /* C — all there. */
  allThere: 'Every visit on its approved quote is here.',
  count: (quote: string, present: number, expected: number) => `${quote} · ${present} of ${expected}`,
  checked: 'checked at approval and every night',

  /* E — one missing; several (§27.7). */
  missingHead: (quote: string, expected: number, missing: number) =>
    `${quote} has ${expected} visits — ${missing === 1 ? '1 is missing' : `${missing} are missing`}.`,
  missing: 'Missing:',
  /** After the name: *· one time · 1 day · 8.0 h · $1,140.00.* */
  missingFacts: (scheduleWords: string, dayCount: number, hours: number, amount: string) =>
    `· ${scheduleWords} · ${days(dayCount)} · ${formatHours(hours)} · ${formatMoneyText(amount)}.`,
  /** After the last *Missing:* line, when the daily check found it. */
  foundBy: (at: string) => `Found by the daily check, ${found(at)}.`,
  /** And for an approval made before visits were checked (`beforeChecks`). */
  approvedBefore: (quote: string, approvedAt: string) =>
    `${quote} was approved ${approvedOn(approvedAt)}, before visits were checked.`,
  create: 'Create the missing visit',
  open: (quote: string) => `Open ${quote}`,
} as const
